import { useParams } from 'react-router-dom';

import { useCreateSectionMutation, useCreateOptionSectionMutation, useGetBomSectionsQuery, useOptionSectionQuery } from '../../queries';
import { useUserEventCount } from '../../../shared/UserActivityTracking/TrackActivityCount';

const useCreateSectionHook = () => {
    const { bomId } = useParams();
    const { pushUserEventCount } = useUserEventCount();

    const { data: sectionData } = useGetBomSectionsQuery(Number(bomId), {
        enabled: Boolean(bomId)
    });

    const { data: optionSectionData } = useOptionSectionQuery(Number(bomId), {
        enabled: Boolean(bomId)
    });

    const { mutateAsync: createSection, isLoading: createLoading } = useCreateSectionMutation();
    const { mutateAsync: createOption, isLoading: createOptionLoading } = useCreateOptionSectionMutation();

    const previousSectionId = sectionData?.data && sectionData.data.length ? sectionData.data[sectionData.data.length - 1].id : null;
    const previousOptionsId = optionSectionData?.data && optionSectionData.data.length ? optionSectionData.data[optionSectionData.data.length - 1].id : null;

    const onCreateSection = async (type: 'products' | 'options', onSectionCreateSuccess?: () => void) => {
        switch (type) {
            case 'products':
                await createSection({
                    bomId: Number(bomId),
                    input: {
                        name: 'New Section',
                        previous_section_id: previousSectionId
                    }
                }, {
                    onSuccess() {
                        if (onSectionCreateSuccess) onSectionCreateSuccess();
                    }
                });
                pushUserEventCount({ eventType: 'section_created', needCummulation: true });

                break;

            case 'options':
                await createOption({
                    bomId: Number(bomId),
                    input: {
                        name: 'New Options Section',
                        previous_substitute_section_id: previousOptionsId
                    }
                }, {
                    onSuccess() {
                        if (onSectionCreateSuccess) onSectionCreateSuccess();
                    }
                });
                pushUserEventCount({ eventType: 'section_created', needCummulation: true });
                break;
        }
    };

    return { onCreateSection, isLoading: createLoading || createOptionLoading }
};

export default useCreateSectionHook;